module.exports = __webpack_public_path__ + "media/stop-11.b6a893bc.mp3";